module.exports = __webpack_public_path__ + "img/customer-industry-problem-icon.ca672b69.png";